import { SRMInfoSchema } from './SRMInfo.styles';

export const srmInfoStyles: SRMInfoSchema = {
  runnerDetails: {
    fontSize: 'xs',
    fontWeight: 'bold',
    color: 'white',
  },
  eventMarketName: {
    fontSize: 'xs',
    fontWeight: 'bold',
    color: 'white',
  },
  eventSubtitle: {
    fontSize: 'xs',
    fontWeight: 'medium',
    color: 'white',
  },
  placeNumber: {
    fontWeight: 'extrabold',
    fontSize: 'xs',
    color: 'white',
    sx: {
      '> span': { fontSize: '2xs', fontWeight: 'medium' },
    },
  },
  srmContainer: {
    w: 'full',
    flexDir: 'column',
    mb: '1',
    pt: '1',
    pb: '2',
    borderBottom: '1px dashed',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.08) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.08)',
    borderBottomColor: 'rgba(0, 0, 0, 0.4)',
    sx: {
      ':first-child': {
        borderTop: '1px dashed',
        borderTopColor: 'rgba(0, 0, 0, 0.4)',
      },
    },
  },
};
